import type { PropsWithChildren } from 'react'
import { HeaderWithAvatar } from '@/layouts'
import { styled } from '@xstyled/styled-components'

export const WebRecorderUnauthenticatedLayout = (
  props: PropsWithChildren
): JSX.Element => {
  return (
    <Root>
      <HeaderWithAvatar />
      {props.children}
    </Root>
  )
}

const Root = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'auto 1fr',
  minHeight: '100%'
})
